import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchGroupMessagesFailure,
  fetchGroupMessagesSuccess,
} from "../slices/features/groupMessages";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* groupMessagesSaga(action: any) {
  const { payload } = action;
  const { id, groupId, meta } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.getGroupMessages,
      baseUrl,
      id,
      groupId,
      meta
    );

    yield put(fetchGroupMessagesSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchGroupMessagesFailure({ statusCode, statusText }));
  }
}

export function* watchGroupMessages() {
  yield takeLatest(RequestTypes.GROUP_MESSAGES_REQUEST, groupMessagesSaga);
}
